import React from 'react';
import PropTypes from 'prop-types';
import DateDivider from '../appointments/DateDivider';
import { ERROR_MESSAGE_SCREEN } from '../../constants';
import { ErrorMessage } from '../common';
import moment from 'moment';
import DataRow from './DataRow';
import NoTasksIcon from 'assets/images/NoTasksIcon.svg';

const TaskList = ({ ...props }) => {
  let currentDate = '';

  const showDate = (task) => {
    const taskDate = moment(task.startTime).format('dddd, MMMM D');
    if (currentDate !== taskDate) {
      currentDate = taskDate;
      return true;
    }
    return false;
  };

  return (
    <ul className='task-list-container'>
      {
        (props.tasks || []).length === 0 ? <ErrorMessage errorMessage={ERROR_MESSAGE_SCREEN.NO_TASKS} errorImage={NoTasksIcon} />
          : (props.tasks || [])
            .sort((a, b) => (moment(a.startTime) - moment(b.startTime)))
            .map((task, index) => {
              return (
                <li key={index}>
                  {showDate(task) ? <DateDivider date={task.startTime} /> : ''}
                  <DataRow task={task} setActiveOpportunity={props.setActiveOpportunity} referrals={props.referrals} />
                </li>
              );
            })
      }
    </ul>
  );
};

TaskList.propTypes = {
  tasks: PropTypes.array.isRequired,
  setActiveOpportunity: PropTypes.func.isRequired,
  referrals: PropTypes.array
};

export default TaskList;
